module.exports = __webpack_public_path__ + "img/vue-logo-facebook.9339b73e.svg";